import { render, staticRenderFns } from "./PcFileDetails.vue?vue&type=template&id=220b2c25&scoped=true&"
import script from "./PcFileDetails.vue?vue&type=script&lang=js&"
export * from "./PcFileDetails.vue?vue&type=script&lang=js&"
import style0 from "./PcFileDetails.vue?vue&type=style&index=0&id=220b2c25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b2c25",
  null
  
)

export default component.exports